import { css } from 'emotion';
import React, { PureComponent } from 'react';
import { mq } from './../../../../css';
import { default as EcoSystemComplex } from './ecoSystem.complex.component';
import { default as EcoSystemSimple } from './ecoSystem.simple.component';

export default class EcoSystem extends PureComponent {
    constructor() {
        super();
    }

    render() {
        return (
            <div className={s.decider}>
                <div className={s.simple}>
                    <EcoSystemSimple />
                </div>
                <div className={s.complex}>
                    <EcoSystemComplex />
                </div>
            </div>
        );
    }
}

const s = {};

s.decider = css`
    position: relative;
    width: 100%;
    height: 100%;
    > div {
        position: relative;
        width: 100%;
        height: 100%;
    }
`;

s.simple = css`
    ${mq({
        display: ['block', 'block', 'none', 'block', 'none'],
    })};
`;

s.complex = css`
    ${mq({
        display: ['none', 'none', 'block', 'none', 'block'],
        minHeight: [0, 0, 600, 0, 600],
        marginTop: [0, 0, -100, 0, 0],
    })};
`;



// WEBPACK FOOTER //
// ./src/components/sections/aboutUs/ecoSystem/ecoSystem.component.js